import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import { getDestinationData } from '../data/destinationData';

interface RelatedDestinationsProps {
  destinationIds: string[];
  title?: string;
}

export const RelatedDestinations: React.FC<RelatedDestinationsProps> = ({ destinationIds, title }) => {
  const { t } = useLanguage();

  if (!destinationIds || destinationIds.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <h3 className="text-xl font-semibold mb-6">
        {title || t('common.relatedDestinations')}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {destinationIds.map((destinationId) => {
          const destinationData = getDestinationData(destinationId);
          if (!destinationData) return null;

          // Use i18n translations for name and subtitle
          const translatedName = t(`destinations.${destinationId}.name`) || destinationData.name;
          const translatedSubtitle = t(`destinations.${destinationId}.subtitle`) || destinationData.subtitle;

          return (
            <Link
              key={destinationId}
              to={`/destination/${destinationId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="block group"
            >
              <div className="bg-gray-50 rounded-lg p-5 hover:bg-gray-100 transition-colors duration-200">
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0 w-32 h-32 rounded-lg overflow-hidden">
                    <img
                      src={`/destinations/${destinationId}/${destinationId}_homepage.webp`}
                      alt={translatedName}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-lg font-semibold text-gray-900 group-hover:text-green-600 transition-colors duration-200">
                      {translatedName}
                    </h4>
                    <p className="text-sm text-gray-600 mt-1">
                      {translatedSubtitle}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}; 